import React from 'react';
import { connect } from 'react-redux';
import {
  Row,
  Col,
  Label,
  Button,
  FormGroup,
  Input,
  Badge,
  Modal,
  ModalHeader,
  ModalBody,
} from 'reactstrap';

import { callApi, formatAmount, formatDateTime, numToWords } from '../../utils';
import { showError, showInfo } from '../../actions/notificationActions';

import Loading from '../Loading';
import { openTransactionModal } from '../../actions/modalActions';
import DataTable from '../DataTable';

class MerchantWallet extends React.Component {
  state = {
    queryParams: {
      from: '',
      to: '',
      q: '',
      disco: '',
      page: 1,
      limit: '30',
      subAccount: '',
      amount: '',
      generatedBy: '1',
      operation: '',
    },
    pages: 1,
    meta: { pages: 1 },
    loading: false,
    rows: [],
    creditModalOpen: false,
    creditForm: {
      ref: '',
      amount: '',
      operation: 'credit',
    },
    crediting: false,
  };

  setInput = (e) => {
    const { name, value } = e.target;
    this.setState({
      queryParams: { ...this.state.queryParams, [name]: value },
    });
    // setQueryParams({[name]: value})
  };

  toggleCreditModal = () => {
    this.setState({
      creditModalOpen: !this.state.creditModalOpen,
      creditForm: { ref: '', amount: '', operation: 'credit' },
    });
  };

  setCreditInput = (e) => {
    const { name, value } = e.target;
    this.setState({
      creditForm: { ...this.state.creditForm, [name]: value },
    });
  };

  submitCredit = (e) => {
    e.preventDefault();
    const { ref, amount, operation } = this.state.creditForm;
    const { merchant } = this.props;
    const phone = merchant.phone;

    if (this.state.crediting) return;

    const prompt = `
Are you sure you want to ${operation} merchant with:

Phone: ${phone}
Amount: ₦ ${amount}

${numToWords(amount).toUpperCase()} NAIRA
    `;

    if (!window.confirm(prompt)) return; // Prompt agent to confirm wallet crediting

    const userId = JSON.parse(localStorage.getItem('auth')).id;

    this.setState({ crediting: true });

    callApi(
      '/wallet/update',
      {
        operation,
        type: operation === 'credit' ? 'topup' : 'reversal',
        channel: 'bank',
        phone,
        amount,
        userId,
        ref,
      },
      'post'
    )
      .then(({ data }) => {
        this.setState({
          crediting: false,
          creditModalOpen: false,
          creditForm: { ref: '', amount: '', operation: 'credit' },
        });
        this.props.dispatch(showInfo(JSON.stringify(data)));
        this.loadTimeline();
      })
      .catch((err) => {
        this.setState({ crediting: false });
        this.props.dispatch(showError(err));
      });
  };

  setPage = (page) => {
    if (page) {
      this.setState(
        { queryParams: { ...this.state.queryParams, page } },
        () => {
          this.loadTimeline();
        }
      );
    }
  };

  startLoad = () => this.setState({ loading: true });
  stopLoad = () => this.setState({ loading: false });

  loadTimeline = async () => {
    const { from, to, page, operation, q } = this.state.queryParams;
    const id = this.props.id;
    this.setState({ loading: true });

    callApi(`/merchants/${id}/wallet-transactions`, {
      from,
      to,
      q,
      operation,
      page,
    })
      .then(({ data = [], meta = {} }) => {
        this.setState({ loading: false });
        this.setState({ rows: data, meta });
      })
      .catch((err) => {
        this.setState({ loading: false });
        this.props.dispatch(showError(err));
      });
  };
  componentWillMount() {
    this.loadTimeline();
  }

  openTransaction = (id) => {
    this.props.dispatch(openTransactionModal({ id }));
  };

  render() {
    const {
      rows,
      queryParams,
      loading,
      meta,
      creditModalOpen,
      creditForm,
      crediting,
    } = this.state;

    const { from, to, operation, q } = queryParams;

    return (
      <Row>
        <Col md="12" xs={12}>
          <div className="mt-10">
            <form
              onSubmit={(e) => {
                e.preventDefault();
                this.getSettlements();
              }}
              className="mb-20"
            >
              <Row className="justify-content-center align-items-center mx-3">
                <div className="text-center">
                  <div>Balance</div>
                  <h5 className="mt-0">
                    {formatAmount(this.props.merchant.wallet)}
                  </h5>
                </div>
                <Button
                  color="success"
                  className="ml-4"
                  onClick={this.toggleCreditModal}
                >
                  Credit / Debit Wallet
                </Button>
              </Row>
              <Row>
                <Col>
                  <FormGroup>
                    <Label>Search</Label>
                    <Input
                      onChange={this.setInput}
                      value={q}
                      name="q"
                      placeholder="Search by Transaction Reference or Phone Number"
                      type="text"
                    />
                  </FormGroup>
                </Col>
              </Row>
              <Row colSpan={3}>
                <Col>
                  <FormGroup>
                    <Label>From</Label>
                    <Input
                      onChange={this.setInput}
                      value={from}
                      name="from"
                      placeholder="From"
                      type="date"
                    />
                  </FormGroup>
                </Col>
                <Col>
                  <FormGroup>
                    <Label>To</Label>
                    <Input
                      onChange={this.setInput}
                      value={to}
                      name="to"
                      placeholder="To"
                      type="date"
                    />
                  </FormGroup>
                </Col>
                <Col>
                  <FormGroup>
                    <Label>Operation</Label>
                    <Input
                      onChange={this.setInput}
                      value={operation}
                      name="operation"
                      placeholder="Operation"
                      type="select"
                    >
                      <option value="">ALL</option>
                      <option value="credit">CREDIT</option>
                      <option value="debit">DEBIT</option>
                    </Input>
                  </FormGroup>
                </Col>
                {/* <Col>
                  <FormGroup>
                    <Label>Amount</Label>
                    <Input
                      onChange={this.setInput}
                      value={amount}
                      name="amount"
                      placeholder="Amount"
                      type="number"
                    />
                  </FormGroup>
                </Col> */}
              </Row>
              <Row className="justify-content-center mx-3">
                {/* <div>
                <div>Balance</div>
                <h5 className="mt-0">{formatAmount(this.props.merchant.wallet)}</h5>
                </div> */}
                <Button size="lg" color="primary" onClick={this.loadTimeline}>
                  {loading ? 'PLEASE WAIT...' : 'Query'}
                </Button>
              </Row>
            </form>

            <DataTable
              card={false}
              loading={loading}
              minWidth={900}
              page={queryParams.page}
              total={meta.pages || 1}
              onPageChange={this.setPage}
            >
              <thead className="text-primary">
                <tr>
                  <th>#</th>
                  <th>Date</th>
                  <th>Reference</th>
                  <th>Amount</th>
                  <th>Balance Before</th>
                  <th>Balance After</th>
                  <th>Type</th>
                </tr>
              </thead>

              <tbody>
                {rows.map((t, i) => {
                  return (
                    <tr
                      // onClick={() => this.openTransaction(t.order_id)}
                      key={t.order_id}
                    >
                      <td>
                        {(queryParams.page - 1) * queryParams.limit + (i + 1)}
                      </td>
                      <td>{formatDateTime(t.created_at)}</td>
                      <td>{t.ref}</td>
                      <td
                        className={
                          t.operation === 'credit'
                            ? 'text-success'
                            : 'text-danger'
                        }
                      >
                        <span className="font-weight-bold">
                          {formatAmount(t.amount)}
                        </span>
                      </td>
                      <td>{formatAmount(t.balance_before)}</td>
                      <td>{formatAmount(t.balance_after)}</td>
                      <td>
                        <Badge>{t.type}</Badge>
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </DataTable>
          </div>
          {/* </Card> */}
        </Col>

        <Modal
          size="lg"
          isOpen={creditModalOpen}
          toggle={this.toggleCreditModal}
          backdrop="static"
        >
          <ModalHeader toggle={this.toggleCreditModal}>
            Credit / Debit Merchant Wallet
          </ModalHeader>
          <ModalBody>
            <form onSubmit={this.submitCredit}>
              <FormGroup>
                <Label>Merchant</Label>
                <Input
                  value={`${this.props.merchant.name || ''} (${
                    this.props.merchant.phone || ''
                  })`}
                  type="text"
                  disabled
                />
              </FormGroup>
              <FormGroup>
                <Label>Reference</Label>
                <Input
                  onChange={this.setCreditInput}
                  value={creditForm.ref}
                  name="ref"
                  placeholder="Reference"
                  type="text"
                  required
                />
              </FormGroup>
              <FormGroup>
                <Label>Amount</Label>
                <Input
                  onChange={this.setCreditInput}
                  value={creditForm.amount}
                  name="amount"
                  placeholder="Amount"
                  type="text"
                  required
                />
              </FormGroup>
              <FormGroup>
                <Label>Operation</Label>
                <Input
                  type="select"
                  name="operation"
                  onChange={this.setCreditInput}
                  value={creditForm.operation}
                >
                  <option value="credit">Credit</option>
                  <option value="debit">Debit</option>
                </Input>
              </FormGroup>
              <hr />

              {crediting && (
                <Row className="justify-content-center">
                  <Loading />
                </Row>
              )}

              <Row className="justify-content-center">
                <Button size="lg" color="primary" type="submit">
                  {crediting ? 'PLEASE WAIT...' : 'CONFIRM'}
                </Button>
              </Row>
            </form>
          </ModalBody>
        </Modal>
      </Row>
    );
  }
}

export default connect()(MerchantWallet);
